import { Layout, Button, Typography, Space, Grid } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosConfig";
import { App } from "antd";

const { Header, Content } = Layout;
const { Title } = Typography;
const { useBreakpoint } = Grid;

const DashboardLayout = ({ children, title }) => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleLogout = async () => {
    try {
      // Use axiosInstance which automatically adds x-api-key header
      await axiosInstance.post("/api/user/logout", {});
      message.success("Logged out successfully!", 3);
    } catch (err) {
      console.log(
        "Logout endpoint not available, performing client-side logout"
      );
      message.info("Logged out", 3);
    } finally {
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("apiKey");
      localStorage.removeItem("user_role");
      localStorage.removeItem("api_credits");
      localStorage.removeItem("api_credits_last_refill");
      navigate("/");
    }
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f4ff 0%, #e6f2ff 100%)",
      }}
    >
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "linear-gradient(135deg, #ffffff 0%, #f8faff 100%)",
          boxShadow: "0 4px 16px rgba(0, 102, 255, 0.08)",
          padding: isMobile ? "0 16px" : "0 32px",
          position: "sticky",
          top: 0,
          zIndex: 100,
          borderBottom: "1px solid #e1e8f0",
          gap: 12,
        }}
      >
        <Title
          level={isMobile ? 4 : 3}
          style={{
            margin: 0,
            background: "linear-gradient(135deg, #0066ff 0%, #0052cc 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            cursor: "pointer",
            fontWeight: 700,
            letterSpacing: "-0.5px",
          }}
          onClick={() => navigate("/dashboard")}
        >
          VerifyU
        </Title>
        <Space size={isMobile ? "small" : "middle"}>
          {title && !isMobile && (
            <Title
              level={5}
              style={{
                margin: 0,
                color: "#0a1629",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              {title}
            </Title>
          )}
          <Button
            type="primary"
            danger
            icon={<LogoutOutlined style={{ fontSize: "14px" }} />}
            onClick={handleLogout}
            aria-label="Logout"
            style={{
              borderRadius: 8,
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(255, 51, 102, 0.2)",
            }}
          >
            {!isMobile && "Logout"}
          </Button>
        </Space>
      </Header>
      <Content
        style={{
          padding: isMobile ? "16px" : "32px",
          maxWidth: "1600px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        {children}
      </Content>
    </Layout>
  );
};

export default DashboardLayout;
